import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

//  http://wiki.xunlei.cn/pages/viewpage.action?pageId=122786351
export enum KindEnum {
  Personal = 1,
  Room = 2,
}
export const getState = (
  state: ReturnType<typeof useVipIDState>,
  kind: KindEnum
) => {
  return {
    [KindEnum.Personal]: state.home.personal,
    [KindEnum.Room]: state.home.room,
  }[kind]
}
export enum LevelEnum {
  D = 1,
  C = 2,
  B = 3,
  A = 4,
  S = 5,
  SS = 6,
}

export interface Ispecial_id_homepage {
  kind: KindEnum
  key?: string
  level_tab?: LevelEnum
}

export const special_id_homepage = createAsyncThunk(
  '/live/vip/special_id_homepage',
  async (arg: Ispecial_id_homepage, store: any) => {
    const {VipID, env} = store.getState()
    const temp = getState(VipID, arg.kind)
    const resp = await http.post<HiyaRes<Ihome>>(
      '/live/vip/special_id_homepage',
      {
        ...env.deviceinfo,
        level_tab: temp.level_tab,
        // key: temp.key,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const special_id_select = createAsyncThunk(
  '/live/vip/special_id_select',
  async (
    arg: {
      kind: KindEnum
      special_id: string
    },
    store: any
  ) => {
    const {env} = store.getState()
    const resp = await http.post<HiyaRes<Ihome>>(
      '/live/vip/special_id_select',
      {
        ...env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

// [个人靓号或房间靓号记录]  http://wiki.xunlei.cn/pages/viewpage.action?pageId=122786382
export const special_id_record = createAsyncThunk(
  '/live/vip/special_id_record',
  async (
    arg: {
      kind: KindEnum
      offset: number
    },
    store: any
  ) => {
    const {env} = store.getState()
    const resp = await http.post<HiyaRes<InitialStateType['record']>>(
      '/live/vip/special_id_record',
      {
        ...env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

interface SpecialIdItem {
  special_id: string
  level: number
  ct: string
  et: string
  icon: string
  text_colors: string[]
  left_bg: string
  middle_bg: string
  right_bg: string
}

interface Ihome {
  member?: any
  list?: Array<SpecialIdItem>

  diy?: boolean
  cur_level?: LevelEnum

  special_id?: SpecialIdItem
  room_id?: string

  level_tab?: LevelEnum
  // 搜索字符
  key?: string
  date?: number
}

export interface InitialStateType {
  home: {
    personal: Ihome
    room: Ihome
  }
  record: {
    list?: SpecialIdItem[]
    offset?: number
    more?: boolean
  }
}

const initialState: InitialStateType = {
  home: {
    personal: {
      key: '',
    },
    room: {
      key: '',
    },
  },
  record: {
    more: true,
  },
}

export const VipIDSlice = createSlice({
  name: 'VipIDSlice',
  initialState,
  reducers: {
    setKey: (
      state,
      action: PayloadAction<{
        kind: KindEnum
        key: Ihome['key']
      }>
    ) => {
      const temp = getState(state, action.payload.kind)
      if (temp) {
        Object.assign(temp, {
          key: action.payload.key,
        })
      }
    },
    clearRecord: (state) => {
      Object.assign(state, {
        record: {
          more: true,
        },
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(special_id_homepage.fulfilled, (state, action) => {
      const temp = getState(state, action.meta.arg.kind)
      if (temp) {
        Object.assign(temp, {
          ...action.payload,
          date: +new Date(),
        })
      }
    })
    builder.addCase(special_id_record.fulfilled, (state, action) => {
      let list
      if (action.payload.offset === 0) {
        list = action.payload.list
      } else {
        list = [...(state.record.list || []), ...(action.payload.list || [])]
      }
      Object.assign(state.record, {
        ...action.payload,
        list,
      })
    })
  },
})
export default VipIDSlice.reducer
export const VipIDActions = VipIDSlice.actions

export const useVipIDState = () => {
  const data = useSelector((state) => {
    return state.VipID
  })
  return data
}
